"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = getFreemiumViralLink;

var _SignupUrlGenerator = _interopRequireDefault(require("signup-ui-core/SignupUrlGenerator"));

var _SignupFlows = require("signup-ui-core/constants/SignupFlows");

var _AllowedHubs = _interopRequireDefault(require("signup-ui-core/constants/AllowedHubs"));

var _AllowedCustomOpts = require("signup-ui-core/constants/AllowedCustomOpts");

var _AllowedIntents = _interopRequireDefault(require("signup-ui-core/constants/AllowedIntents"));

var _AllowedUtms = _interopRequireDefault(require("signup-ui-core/constants/AllowedUtms"));

var _utils = require("MeetingsBase/utils/utils");

function getFreemiumViralLink(viralPage, portalId) {
  var embedded = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var campaign = embedded ? 'hubspot-meetings-embedded-virality' : 'hubspot-meetings-virality';
  var salesUrl = new _SignupUrlGenerator.default(_SignupFlows.SignupFlows.SALES).withHubs(_AllowedHubs.default.HUBS_CAMPAIGN, campaign).withHubs(_AllowedHubs.default.HUBS_CTA, viralPage).withUtm(_AllowedUtms.default.UTM_MEDIUM, 'virality').withOption(_AllowedCustomOpts.MEETING_SIDEBAR).withIntent(_AllowedIntents.default.MEETINGS).withParam(_AllowedCustomOpts.VIRAL_SOURCE_PORTAL_ID, portalId).getUrl();
  var envPostfix = (0, _utils.getEnvPostfix)();
  return "https://app.hubspot" + envPostfix + ".com" + salesUrl;
}

module.exports = exports.default;